import { createContext } from 'react';

import { SelectedTerminalContextProps } from './SelectedTerminalContext.types';

export const SelectedTerminalContext = createContext<SelectedTerminalContextProps | undefined>(undefined);
